import request from '@/common/request'
import { commonParams } from '@/api/config'
import { getToken } from '@/common/auth'

export function Query(pageIndex, pageSize, sortKey, sortDirect, filters) {
  const loginKey = getToken()
  return request({
    url: './query/QueryEnterprise',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      pageIndex,
      pageSize,
      sortKey,
      sortDirect,
      filters
    })
  })
}

export function Add(Enterprise1, ContactName, ContactNo, Email, LoginName, Pswd, FunIds) {
  const loginKey = getToken()
  return request({
    url: './add/AddEnterprise',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      Enterprise1,
      ContactName: ContactName || '',
      ContactNo: ContactNo || '',
      Email: Email || '',
      LoginName,
      Pswd,
      FunIds
    })
  })
}

export function Delete(EIDs) {
  const loginKey = getToken()
  return request({
    url: './delete/DeleteEnterprise',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      EIDs,
      Force: true
    })
  })
}

export function Modify(EID, Enterprise1, ContactName, ContactNo, Email, LoginName, Pswd, FunIds) {
  const loginKey = getToken()
  return request({
    url: './modify/ModifyEnterprise',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey,
      EID,
      Enterprise1,
      ContactName,
      ContactNo,
      Email,
      LoginName,
      Pswd,
      FunIds
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/enterprise.js